// ──────────────────────────────────────────────────────────────
//  Registry of code snippets / mini-pages.
//  Add a new entry here and a matching <Route> in App.js to publish
//  another snippet — the gallery renders straight off this list.
// ──────────────────────────────────────────────────────────────

const snippets = [
  {
    slug: 'sa-payslip-calculator',
    path: '/snippets/sa-payslip-calculator',
    title: 'SA Payslip Calculator',
    description:
      'Interactive South African payslip calculator for the 2026/27 tax year — PAYE, UIF, overtime and bonus tax impact.',
    tags: ['React', 'Tax', 'SARS', 'Calculator'],
    accent: '#0F6E56',
    icon: '🧾',
  },
];

export default snippets;
